import React from "react";

import "./piecePageDisplay.css";
import StraightArrowIcon from "../../assets/icons/straightArrowIcon";

interface PiecePageDisplayProps {
    currentPage: number;
    setCurrentPage: (page: number) => void;
    totalPages: number;
}

export default function PiecePageDisplay(props: PiecePageDisplayProps) {

    if( props.totalPages <= 1) {
        return <div className="piece-page-display"/>;
    }

    return <div className="piece-page-display">
        <div onClick={() => {
            if (props.currentPage > 0) {
                props.setCurrentPage(props.currentPage - 1);
            }
        }} className={"navigate-arrow back" + (props.currentPage == 0 ? " disabled" : "")}>
            <StraightArrowIcon/>
        </div>
        <div className="page-numbers">
            {Array.from({ length: props.totalPages }, (_, i) => (
                <a onClick={() => {
                    props.setCurrentPage(i);
                }} className={"page-number" + (i == props.currentPage ? " active" : "")} key={i + 1}>{i + 1}</a>
            ))}
        </div>
        <div onClick={() => {
            if (props.currentPage < props.totalPages - 1) {
                props.setCurrentPage(props.currentPage + 1);
            }
        }} className={"navigate-arrow forward" + (props.currentPage == props.totalPages - 1 ? " disabled" : "")}>
            <StraightArrowIcon/>
        </div>
    </div>

}